import { render, staticRenderFns } from "./Online.vue?vue&type=template&id=3524c51b&scoped=true"
import script from "./Online.vue?vue&type=script&lang=js"
export * from "./Online.vue?vue&type=script&lang=js"
import style0 from "./Online.vue?vue&type=style&index=0&id=3524c51b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524c51b",
  null
  
)

export default component.exports